import { WithStyles, withStyles } from '@mui/styles';
import { FilterModel, SortModel } from '@tassat/common-definitions';
import { UserRecordRoleDisplay } from '@tassat/fred-extended-definitions';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { AdminUsersGrid } from './adminUsersGrid';
import { muiStyles } from './adminUsersGridStyles';

export interface AdminUsersGridProps extends WithStyles<typeof muiStyles>,
    RouteComponentProps<any, any, { filterModel: { string: FilterModel }; sortModel: SortModel[]; adminUserId: string }> {
    filterModel: { string: FilterModel };
    sortModel: SortModel[];
    setFilterModel: React.Dispatch<React.SetStateAction<{ string: FilterModel }>>;
    setSortModel: React.Dispatch<React.SetStateAction<SortModel[]>>;
    adminUsers: UserRecordRoleDisplay[];
    adminUserId?: string;
}

export default withRouter(withStyles(muiStyles)(AdminUsersGrid));